<template>
<div class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>